const table = [
  {
    prop: 'name',
    label: 'Nombre',
    minWidth: 200
  },
]

const table_plus = [    
  {
    prop: 'guard_name',
    label: 'Nombre de Guardia',
  },
  {
    prop: 'modules_names',
    label: 'Modulos Asociados',
  },
]

export default [table, table_plus]